<template>
  <nav role="navigation">
    <div class="container">
      <div>

        <span>
          <span></span>
          <span></span>
          <span></span>
        </span>

      </div>
      <div class="navbar-content">
        <div class="navbar-startt no-hover" v-on:click.native="closeMenu">
          <router-link class="navbar-item" v-on:click.native="closeMenu" to="/"> Home</router-link>
          <router-link to="/holiday" v-on:click.native="closeMenu" class="navbar-item">Holiday</router-link>
          <router-link to="/everyday" v-on:click.native="closeMenu" class="navbar-item">Everyday</router-link>
          <router-link to="/weddings-&-events" v-on:click.native="closeMenu" class="navbar-item">Weddings/Events</router-link>
          <router-link to="/about" v-on:click.native="closeMenu" class="navbar-item">About Us</router-link>
          <router-link to="/contact" v-on:click.native="closeMenu" class="navbar-item">Contact</router-link>
          <router-link to="/cart" class="navbar-item" v-on:click.native="closeMenu"> <i class="fa fa-shopping-cart"></i>{{ cartCount }} Items</router-link>
          <router-link to="/login" class="navbar-item" v-on:click.native="closeMenu" v-if="user === null"> <i class="fa fa-user"></i> Login </router-link>

          <div class="mt" v-if="user !== null">
            <div>Hello, {{ user.first_name }}</div>
            <router-link to="/admin/0" class="navbar-item" v-on:click.native="closeMenu">My Account</router-link>
            <!-- <router-link to="/me/overview" class="navbar-item" v-on:click.native="closeMenu">Admin Info</router-link> -->
            <a class="navbar-item" @click="logOut" v-on:click.native="closeMenu">Log Out</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<style>
.tall {
  min-height: 10em;
}

.map {
  width: 100%;
  height: 100%;
}

#app {
  display: flex;
  min-height: 100vh;
  height: 100%;
  flex-direction: column;
}

.Site-footer .Site-header {
  flex: none;
}

.Site-content {
  flex: 1 0 auto;
  width: 100%;
}

.Site-content::after {
  display: block;
  height: 0;
  visibility: hidden;
}

body {
  width: 100%;
  height: 100%;
}

.slideout-menu {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  width: 235px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  display: none;
}

.slideout-panel {
  position: relative;
  z-index: 1;
}

.slideout-open,
.slideout-open body,
.slideout-open .slideout-panel {
  overflow: hidden;
}

.slideout-open .slideout-menu {
  display: block;
}

.burger {
  margin-left: 0;
}
</style>

<script>
import MenuDropdownItem from './jquery/MenuDropdownItem';
let slideout;
export default {
  components: {
    MenuDropdownItem,
  },

  name: 'NavBar',

  mounted() {
    slideout = new Slideout({
      panel: document.getElementById('panel'),
      menu: document.getElementById('menu'),
      padding: 235,
      tolerance: 70,
    });
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    menus() {
      return this.$store.state.menu.menus;
    },

    cartCount() {
      if (this.$store.state.cart.cart === null) return 0;

      return this.$store.state.cart.cart.length;
    },
  },

  methods: {
    logOut() {
      this.$store.dispatch('auth/logout').then(() => this.$router.push('/'));
      //Super hacky NEVER do this!
      slideout.toggle();
      slideout.toggle();
    },
    closeMenu() {
      //Super hacky NEVER do this!
      slideout.toggle();
      slideout.toggle();
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/NavBar.vue